import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { useRoles } from "../../../../../hooks/query";

export default function useCreateRole() {
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { useCreate } = useRoles();
    const createRoleSvc = useCreate();

    const handleCreateRole = async (values: any) => {
        try {
            await createRoleSvc.mutateAsync(values);
            queryClient.invalidateQueries({ queryKey: ["roles"] });
            navigate("/admin/roles");
        } catch (error) {
            console.error("Error creating role:", error);
            throw error;
        }
    };

    return {
        handleCreateRole,
        createRoleSvc,
    };
}
